import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import environment from "../../config/environment";
interface Loader {
    isLoading: boolean;
}

interface Alert {
    isVisible: boolean;
    message: string;
}
interface Key {
    key: string;
}
const setSessionKey = (data: object, token: string) => {

};

export const setLoader = createAction("LOADER", function prepare(
    loader: Loader
) {
    return {
        payload: loader
    };
});

export const setAlert = createAction("ALERT", function prepare(alert: Alert) {
    return {
        payload: alert
    };
});
